// src/pages/AllShopPage.jsx

import React, {
  useMemo,
  useState,
  useEffect,
  useRef
} from 'react';

import {
  Search,
  X
} from 'lucide-react';

import {
  useSearchParams
} from 'react-router-dom';

import ProductCard from '../components/ProductCard';
import { theme } from '../utils/constants';



export default function AllShopPage({
  products,
  addToCart,
  navigateTo
}) {


  const [searchParams, setSearchParams] = useSearchParams();


  const [selectedCategory, setSelectedCategory] = useState('all');


  const [searchTerm, setSearchTerm] = useState(
    searchParams.get('search') || ''
  );


  const [showSuggestions, setShowSuggestions] = useState(false);


  const searchRef = useRef();



  /*
    Keep input synced when URL changes
  */
  useEffect(()=>{

    setSearchTerm(
      searchParams.get('search') || ''
    );

  },[searchParams]);




  /*
     Search logic
  */

  const filteredProducts = useMemo(()=>{


    return products.filter(product=>{


      const categoryMatch =
        selectedCategory === 'all'
        ||
        product.category === selectedCategory;



      const term =
        searchTerm.toLowerCase();



      const searchMatch =

        product.title
        ?.toLowerCase()
        .includes(term)

        ||

        product.author
        ?.toLowerCase()
        .includes(term)

        ||

        product.category
        ?.toLowerCase()
        .includes(term);



      return categoryMatch && searchMatch;


    });


  },[
    products,
    selectedCategory,
    searchTerm
  ]);





  /*
     Suggestions
  */

  const suggestions = useMemo(()=>{


    if(!searchTerm.trim()) return [];


    return products
      .filter(product=>{


        const value =
        searchTerm.toLowerCase();



        return (

          product.title
          ?.toLowerCase()
          .includes(value)

          ||

          product.author
          ?.toLowerCase()
          .includes(value)

        );


      })
      .slice(0,5);



  },[
    products,
    searchTerm
  ]);





  const updateSearch = (value)=>{


    setSearchTerm(value);


    if(value.trim()){

      setSearchParams({
        search:value
      });

    }
    else{

      setSearchParams({});

    }


  };





  const selectSuggestion=(product)=>{


    setSearchTerm(product.title);


    setSearchParams({
      search:product.title
    });


    setShowSuggestions(false);


  };






return (

<section

style={{

padding:'6rem 24px',

background:'#fff'

}}

>


<div

style={{

maxWidth:'1280px',

margin:'0 auto'

}}

>



<h2

style={{

textAlign:'center',

fontSize:'2.8rem',

marginBottom:'1rem',

fontFamily:"'Roboto Slab', serif"

}}

>

Complete Collection

</h2>






{/* SEARCH */}

<div

ref={searchRef}

style={{

maxWidth:'650px',

margin:'0 auto',

position:'relative'

}}

>


<div

style={{

position:'relative'

}}

>


<Search

size={22}

style={{

position:'absolute',

left:18,

top:'50%',

transform:'translateY(-50%)',

color:theme.textLight

}}

/>



<input


value={searchTerm}


onFocus={()=>setShowSuggestions(true)}


onChange={(e)=>{

updateSearch(e.target.value);

setShowSuggestions(true);

}}



placeholder="Search books, authors, accessories..."



style={{

width:'100%',

padding:'1rem 3.5rem',

borderRadius:'50px',

border:

`1px solid ${theme.border}`,

fontSize:'1rem',

outline:'none',

boxShadow:
'0 10px 30px rgba(0,0,0,.08)'


}}


/>



{
searchTerm &&

<X

size={20}

onClick={()=>updateSearch('')}


style={{

position:'absolute',

right:18,

top:'50%',

transform:'translateY(-50%)',

cursor:'pointer',

color:theme.textLight

}}

/>

}



</div>






{/* Suggestions dropdown */}

{

showSuggestions &&

suggestions.length > 0 &&

(

<div

style={{

position:'absolute',

top:'60px',

left:0,

right:0,

background:'#fff',

borderRadius:'16px',

boxShadow:'0 20px 40px rgba(0,0,0,.15)',

overflow:'hidden',

zIndex:20

}}

>


{
suggestions.map(product=>(


<div

key={product.id}

onClick={()=>selectSuggestion(product)}


style={{

display:'flex',

alignItems:'center',

gap:'15px',

padding:'14px 18px',

cursor:'pointer',

borderBottom:
`1px solid ${theme.border}`

}}

>


<img

src={product.image}

alt={product.title}

style={{

width:45,

height:45,

borderRadius:8,

objectFit:'cover'

}}

/>


<div>


<div

style={{

fontWeight:600

}}

>

{product.title}

</div>


<div

style={{

fontSize:'.85rem',

color:theme.textLight

}}

>

{product.author}

</div>


</div>



</div>



))

}


</div>

)

}


</div>








<p

style={{

textAlign:'center',

color:theme.textLight,

margin:'2rem 0'

}}

>

Showing {filteredProducts.length} products

</p>








{/* CATEGORY BUTTONS */}


<div

style={{

display:'flex',

justifyContent:'center',

gap:'1rem',

marginBottom:'3.5rem',

flexWrap:'wrap'

}}

>


{

[
'all',
'books',
'accessories'

].map(cat=>(


<button

key={cat}

onClick={()=>setSelectedCategory(cat)}

style={{


background:

selectedCategory===cat

?

theme.primary

:

'transparent',



color:

selectedCategory===cat

?

'#fff'

:

theme.primary,



border:

`2px solid ${theme.primary}`,



padding:

'.8rem 1.8rem',



borderRadius:'50px',



fontWeight:600,



cursor:'pointer'


}}

>


{
cat==='all'

?

'All Products'

:

cat.charAt(0).toUpperCase()+cat.slice(1)

}


</button>


))


}


</div>









{/* PRODUCTS */}


<div

style={{

display:'grid',

gridTemplateColumns:

'repeat(auto-fit,minmax(280px,1fr))',

gap:'2rem'

}}

>


{

filteredProducts.length===0 ?


(

<div

style={{

gridColumn:'1/-1',

textAlign:'center',

padding:'4rem'

}}

>


<h3>

No products found

</h3>


<p

style={{

color:theme.textLight

}}

>

Try another search phrase.

</p>


</div>

)


:

filteredProducts.map(product=>(


<ProductCard

key={product.id}

product={product}

addToCart={addToCart}

navigateTo={navigateTo}


/>


))


}


</div>




</div>


</section>


);


}

// // src/pages/AllShopPage.jsx
// import React, { useMemo, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import ProductCard from '../components/ProductCard';
// import { theme } from '../utils/constants';
// import { Search, X } from 'lucide-react';


// export default function AllShopPage({
//   products,
//   addToCart,
//   navigateTo
// }) {

//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [searchTerm, setSearchTerm] = useState('');


//   const filteredProducts = useMemo(() => {

//     return products.filter(product => {

//       const matchesCategory =
//         selectedCategory === 'all'
//           ? true
//           : product.category === selectedCategory;


//       const search =
//         searchTerm.toLowerCase();


//       const matchesSearch =
//         product.title?.toLowerCase().includes(search) ||
//         product.author?.toLowerCase().includes(search) ||
//         product.category?.toLowerCase().includes(search);


//       return matchesCategory && matchesSearch;

//     });

//   }, [
//     products,
//     selectedCategory,
//     searchTerm
//   ]);



//   return (

// <section style={{
// padding:'6rem 24px',
// background:'white'
// }}>

// <div style={{
// maxWidth:'1280px',
// margin:'0 auto'
// }}>


// <h2
// style={{
// textAlign:'center',
// fontSize:'2.8rem',
// marginBottom:'1rem',
// fontFamily:"'Roboto Slab', serif"
// }}
// >
// Complete Collection
// </h2>



// {/* Search Box */}

// <div
// style={{
// maxWidth:'600px',
// margin:'0 auto 2rem',
// position:'relative'
// }}
// >


// <Search
// size={22}
// style={{
// position:'absolute',
// left:'18px',
// top:'50%',
// transform:'translateY(-50%)',
// color:theme.textLight
// }}
// />


// <input

// value={searchTerm}

// onChange={(e)=>setSearchTerm(e.target.value)}

// placeholder="Search books, authors, accessories..."

// style={{

// width:'100%',
// padding:'1rem 3rem',
// borderRadius:'50px',
// border:`1px solid ${theme.border}`,
// fontSize:'1rem',
// outline:'none',
// boxShadow:'0 5px 20px rgba(0,0,0,.06)',
// transition:'all .25s'

// }}

// />


// {
// searchTerm && (

// <X

// size={20}

// onClick={()=>setSearchTerm('')}

// style={{
// position:'absolute',
// right:'18px',
// top:'50%',
// transform:'translateY(-50%)',
// cursor:'pointer',
// color:theme.textLight
// }}

// />

// )
// }


// </div>



// {/* Result Count */}

// <p
// style={{
// textAlign:'center',
// color:theme.textLight,
// marginBottom:'2rem'
// }}
// >
// Showing {filteredProducts.length} products
// </p>




// {/* Categories */}

// <div
// style={{
// display:'flex',
// justifyContent:'center',
// gap:'1rem',
// marginBottom:'3.5rem',
// flexWrap:'wrap'
// }}
// >

// {
// [
// 'all',
// 'books',
// 'accessories'

// ].map(cat=>(

// <button

// key={cat}

// onClick={()=>setSelectedCategory(cat)}

// style={{

// background:selectedCategory===cat
// ?theme.primary
// :'transparent',

// color:selectedCategory===cat
// ?'white'
// :theme.primary,

// border:`2px solid ${theme.primary}`,

// padding:'0.8rem 1.8rem',

// borderRadius:'50px',

// fontWeight:500,

// cursor:'pointer',

// transition:'all .25s'

// }}

// >

// {
// cat==='all'
// ?'All Products'
// :cat.charAt(0).toUpperCase()+cat.slice(1)

// }

// </button>


// ))

// }

// </div>




// {/* Products */}

// <div

// style={{

// display:'grid',

// gridTemplateColumns:
// 'repeat(auto-fit,minmax(280px,1fr))',

// gap:'2rem'

// }}

// >


// {
// filteredProducts.length===0 ?

// (

// <div

// style={{

// gridColumn:'1/-1',

// textAlign:'center',

// padding:'4rem'

// }}

// >

// <h3>
// No products found
// </h3>

// <p style={{
// color:theme.textLight
// }}>
// Try another search term.
// </p>


// </div>

// )

// :

// filteredProducts.map(product=>(

// <ProductCard

// key={product.id}

// product={product}

// addToCart={addToCart}

// navigateTo={navigateTo}

// />

// ))

// }


// </div>



// </div>

// </section>

// );

// }
// // src/pages/AllShopPage.jsx
// import React, { useState } from 'react';

// import ProductCard from '../components/ProductCard';
// import { theme } from '../utils/constants';

// export default function AllShopPage({
//   products,
//   addToCart,
//   navigateTo
// }) {
//   // Local state — no longer depends on props from App
//   const [selectedCategory, setSelectedCategory] = useState('all');

//   // Filter products based on selected category
//   const filteredProducts =
//     selectedCategory === 'all'
//       ? products
//       : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '6rem 24px', background: 'white' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2
//           style={{
//             textAlign: 'center',
//             fontSize: '2.8rem',
//             marginBottom: '2.5rem',
//             fontFamily: "'Roboto Slab', serif"
//           }}
//         >
//           Complete Collection
//         </h2>

//         {/* Category Filter Buttons */}
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'center',
//             gap: '1rem',
//             marginBottom: '3.5rem',
//             flexWrap: 'wrap'
//           }}
//         >
//           {['all', 'books', 'accessories'].map(cat => (
//             <button
//               key={cat}
//               onClick={() => setSelectedCategory(cat)}
//               style={{
//                 background: selectedCategory === cat ? theme.primary : 'transparent',
//                 color: selectedCategory === cat ? 'white' : theme.primary,
//                 border: `2px solid ${theme.primary}`,
//                 padding: '0.8rem 1.8rem',
//                 borderRadius: '50px',
//                 fontWeight: 500,
//                 cursor: 'pointer',
//                 transition: 'all 0.25s'
//               }}
//             >
//               {cat === 'all' ? 'All Products' : cat.charAt(0).toUpperCase() + cat.slice(1)}
//             </button>
//           ))}
//         </div>

//         {/* Product Grid */}
//         <div
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//             gap: '2rem'
//           }}
//         >
//           {filteredProducts.length === 0 ? (
//             <p style={{ textAlign: 'center', fontSize: '1.3rem', color: theme.textLight, gridColumn: '1 / -1' }}>
//               No products found in this category.
//             </p>
//           ) : (
//             filteredProducts.map(product => (
//               <ProductCard
//                 key={product.id}
//                 product={product}
//                 addToCart={addToCart}
//                 navigateTo={navigateTo}           // fixed typo (was goto)
//               />
//             ))
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }
// // src/pages/AllShopPage.jsx
// import React from 'react';

// import ProductCard from '../components/ProductCard';

// import { theme } from '../utils/constants';

// export default function AllShopPage({
//   products,
//   addToCart,
//   selectedCategory,
//   setSelectedCategory,
//   navigateTo
// }) {
//   // Filter products based on selected category
//   const filteredProducts =
//     selectedCategory === 'all'
//       ? products
//       : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '6rem 24px', background: 'white' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2
//           style={{
//             textAlign: 'center',
//             fontSize: '2.8rem',
//             marginBottom: '2.5rem',
//             fontFamily: "'Roboto Slab', serif"
//           }}
//         >
//           Complete Collection
//         </h2>

//         {/* Category Filter Buttons */}
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'center',
//             gap: '1rem',
//             marginBottom: '3.5rem',
//             flexWrap: 'wrap'
//           }}
//         >
//           {['all', 'books', 'accessories'].map(cat => (
//             <button
//               key={cat}
//               onClick={() => setSelectedCategory(cat)}
//               style={{
//                 background: selectedCategory === cat ? theme.primary : 'transparent',
//                 color: selectedCategory === cat ? 'white' : theme.primary,
//                 border: `2px solid ${theme.primary}`,
//                 padding: '0.8rem 1.8rem',
//                 borderRadius: '50px',
//                 fontWeight: 500,
//                 cursor: 'pointer',
//                 transition: 'all 0.25s'
//               }}
//             >
//               {cat === 'all' ? 'All Products' : cat.charAt(0).toUpperCase() + cat.slice(1)}
//             </button>
//           ))}
//         </div>

//         {/* Product Grid */}
//         <div
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//             gap: '2rem'
//           }}
//         >
//           {filteredProducts.map(product => (
//             <ProductCard
//               key={product.id}
//               product={product}
//               addToCart={addToCart}
//               goto={navigateTo}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }